/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { effects } from "./effects";
import { Avatar } from "./Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: ${effects.cardRest};
`;

const upperSectionStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  justify-content: space-between;
  padding: 16px;
  background-color: ${colors.white};
  border: none;
  cursor: pointer;
  &:hover {
    background-color: ${colors.whiteHover};
  }
`;

const lowerSectionStyle = css`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 16px;
  background-color: ${colors.whiteHover};
  border-top: 1px dashed ${colors.greyBorder};
`;

const upperLeftSectionStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;

const textSectionStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const upperRightSectionStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

type Props = {
  title: string;
  subtitle?: string;
  onClick: () => void;
  onClickCtaText: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  rightComponent?: React.ReactNode;
};

export const ListItemSelector = ({
  title,
  subtitle,
  onClick,
  onClickCtaText,
  children,
  icon,
  rightComponent,
}: Props) => {
  return (
    <div css={wrapperStyle}>
      <button css={upperSectionStyle} onClick={onClick}>
        <div css={upperLeftSectionStyle}>
          {icon && <Avatar rounded={false}>{icon}</Avatar>}
          <div css={textSectionStyle}>
            <StyledText
              className="bodyTextSemibold mb-0"
              color={colors.textPrimary}
            >
              {title}
            </StyledText>
            {subtitle && (
              <StyledText
                className="bodySubtextRegular mb-0"
                color={colors.textSecondary}
              >
                {subtitle}
              </StyledText>
            )}
          </div>
        </div>
        <div css={upperRightSectionStyle}>
          {rightComponent && rightComponent}
          <StyledText
            className="bodyTextSemibold mb-0"
            color={colors.blueInteractive}
          >
            {onClickCtaText}
          </StyledText>
          <StyledText
            className="bodyTextSemibold mb-0"
            color={colors.blueInteractive}
          >
            <FontAwesomeIcon icon={solid("chevron-right")} />
          </StyledText>
        </div>
      </button>
      <div css={lowerSectionStyle}>{children}</div>
    </div>
  );
};
